<template>
    <div>
      <AlertTemplate :setting="setting"/>
      <div class="flex items-center justify-between">
        <div>
          <div v-if="setting.templates && setting.templates.avatar" class="flex space-y-logo">
<!--            <a-avatar :src="setting.templates.avatar" :size="120" style="box-shadow: rgb(0 0 0 / 10%) 0 1px 0 0"/>-->
<!--            <img :src="setting.templates.avatar" width="120" height="75" alt="avatar" class="object-cover"/>-->
            <img :src="setting.templates.avatar" alt="avatar" class="object-contain" style="width: 10rem;"/>
          </div>
          <a-avatar v-else :size="120" icon="user" />
        </div>
        <div v-if="setting.accounts" class="flex flex-col">
          <div>
            <strong>{{ setting.accounts.firm_name || '__' }}</strong>
            <div class="w-64">
              {{ setting.accounts.street }}
            </div>
          </div>
          <br>
          <div>
            <div class="w-64">
              {{ setting.accounts.phone }}
            </div>
            <div class="w-64">
              {{ setting.accounts.contact_website }}
            </div>
          </div>
        </div>
      </div>
      <div class="h-divider my-12">
        <div class="shadow"></div>
        <div class="text"><i>Invoice</i></div>
      </div>
      <div v-if="items.record && items.data" class="pt-4">
        <a-descriptions :column="2">
<!--          <a-descriptions-item label="Legal Name">{{ items.data.legalName }}</a-descriptions-item>-->
          <a-descriptions-item label="Invoice Number">{{ items.record.factor_no || '__' }}</a-descriptions-item>
          <a-descriptions-item label="Invoice Date">{{ setDateFormat(items.record.issue_date) }}</a-descriptions-item>
          <a-descriptions-item label="Payment Due">{{ setDateFormat(items.record.due_date) }}</a-descriptions-item>
          <a-descriptions-item v-if="items.record.matters && items.record.matters.length" label="Our Reference">{{ items.record.matters[0].reference_code }}</a-descriptions-item>
        </a-descriptions>
      </div>
      <a-divider/>
      <DescriptionTblBill 
        :items="items"
        :setting="setting"
        @amountDueChanged="$emit('amountDueChanged', $event)"
      />
    </div>
</template>

<script>

import DescriptionTblBill from "./components/DescriptionTblBill";
import AlertTemplate from "@/views/template/components/AlertTemplate";
import mixin from '@/views/mixin/mixin'

export default {
  name: "Template3",
  mixins:[mixin],
  components:{
    DescriptionTblBill,
    AlertTemplate
  },
  props:{
    items:{
      type     : Object,
      required : true,
    },
    setting:{
      type     : Object,
      required : false,
    }
  },
}
</script>

<style>


.h-divider {
  margin: auto;
  position: relative;
}

.h-divider .shadow {
  overflow: hidden;
  height: 1px;
}

.h-divider .shadow:after {
  content: '';
  display: block;
  margin: -25px auto 0;
  width: 100%;
  height: 25px;
  border-radius: 125px/12px;
  box-shadow: 0 0 8px #3A3DBE;
}

.h-divider .text {
  width: 70px;
  height: 45px;
  padding: 40px;
  position: absolute;
  bottom: 100%;
  margin-bottom: -35px;
  left: 52%;
  margin-left: -60px;
  border-radius: 50%;
  box-shadow: 0 2px 4px #999;
  background: white;
}

.h-divider .text i {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  right: 4px;
  border-radius: 100%;
  border: 1px dashed #3A3DBE;
  text-align: center;
  line-height: 5em;
  font-style: normal;
  color: #3A3DBE;
}

</style>
